// eslint configured: rule not present in CRA build
import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function PwaInstallBanner() {
  const [evt, setEvt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    if (sessionStorage.getItem("pwa-dismissed")) setDismissed(true);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!evt || dismissed) return null;

  const install = async () => { evt.prompt(); await evt.userChoice; setEvt(null); };
  const close = () => { sessionStorage.setItem("pwa-dismissed", "1"); setDismissed(true); };

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed top-3 left-3 right-3 md:left-auto md:right-6 md:top-6 md:w-80 z-[60] backdrop-blur-xl rounded-xl p-4 shadow-2xl"
      style={{ background: "rgba(26,17,8,0.95)", border: "1px solid var(--ink-22)" }}
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "var(--seal)", color: "var(--bg)" }}>
          <Download size={16} />
        </div>
        <div className="flex-1">
          <div className="text-sm font-medium" style={{ fontFamily: "'Fraunces', serif", fontVariationSettings: "'opsz' 24, 'wght' 500" }}>
            Install PintaFlow
          </div>
          <div className="text-xs mt-0.5" style={{ color: "var(--ink-55)" }}>
            Add to home screen for offline access.
          </div>
          <div className="flex gap-2 mt-3">
            <button data-testid="pwa-install-confirm" onClick={install} className="btn-primary text-xs !px-3 !py-1.5">Install</button>
            <button data-testid="pwa-install-dismiss" onClick={close} className="btn-ghost text-xs">Later</button>
          </div>
        </div>
        <button onClick={close} style={{ color: "var(--ink-55)" }}>
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
